import api from "Common/Client/Interceptor";

const BASE_URL = "/Learners/Profile";

export const fetchManagerProfile = async (token) => {
  try {
    const response = await api.get(BASE_URL, {
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching manager profile:", error);
    throw error; // Aage propagate karne ke liye
  }
};

export const updateManagerProfile = async (token, values, fileList) => {
  try {
    const formData = new FormData();

    if (fileList.length > 0 && fileList[0].originFileObj) {
      formData.append("ImageFile", fileList[0].originFileObj);
    }

    const queryParams = new URLSearchParams();
    queryParams.append("FirstName", values.firstName);
    queryParams.append("LastName", values.lastName);
    queryParams.append("PhoneNo", values.phoneNo);
    queryParams.append("Country", values.country);
    queryParams.append("State", values.state);
    queryParams.append("City", values.city);
    queryParams.append("BusinessGroupId", values.businessGroupId);

    const response = await api.put(`${BASE_URL}?${queryParams.toString()}`, formData, {
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error updating manager profile:", error);
    throw error; // Aage propagate karne ke liye
  }
};
